import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type UpgradeButtonClickedParams = {
  plan: string;
  page: string;
  location: string;
};

/**
 * Logs event for when a user clicks an "Upgrade" button with context about where it was clicked
 */
export const useTrackUpgradeButtonClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackUpgradeButtonClicked = useCallback(
    (params: UpgradeButtonClickedParams) => {
      track('Upgrade Button Clicked', params);
    },
    [track],
  );

  return { trackUpgradeButtonClicked };
};
